import * as React from "react";

import { Button, Typography, Box } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
// import { makeStyles } from "@mui/material/styles";

import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

// const useStyles = makeStyles((theme) => ({
//   dialogContent: {
//     fontSize: "24px",
//     fontWeight: "500",
//     color: "#929dad",
//     paddingTop: "5px",
//     marginTop: "10px",
//   },
//   dialogueActions: {
//     paddingBottom: "25px",
//     paddingRight: "20px",
//   },
//   signOutTypography: {
//     fontSize: "36px",
//     color: "#151b24",
//     fontWeight: "500",
//   },
// }));

const Centerstyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom:'10px'
};

const CancelButtonStyle = styled(Button)({
  backgroundColor: "white",
  color: "#2D6A4F",
  textTransform: "none",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "120px",
  maxWidth: "150px",
});

const ButtonStyle = styled(Button)({
  backgroundColor: "#2D6A4F",
  color: "white",
  textTransform: "none",
  borderRadius: "12px",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "120px",
  maxWidth: "200px",
});

export default function BasicDialog({
  open,
  handleClose,
  heading,
  text,
  saveButtonText,
  handleLogout,
}) {
  // const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { width: "500px", height: "200px" } }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography
            sx={{ fontSize: "28px" }}
            // className={classes.signOutTypography}
          >
            {heading}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
          >
            <CloseRoundedIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography
        // className={classes.dialogContent}
        >
          {text}
        </Typography>
      </DialogContent>
      <DialogActions
        // className={classes.dialogueActions}
        sx={Centerstyle}
      >
        <CancelButtonStyle variant="contained" onClick={handleClose}>
          Cancel
        </CancelButtonStyle>
        <ButtonStyle variant="contained" name="signout" onClick={handleLogout}>
          {saveButtonText}
        </ButtonStyle>
      </DialogActions>
    </Dialog>
  );
}
